import {
  SAVE_NEXT_VIDEO_ID,
  SAVE_NEXT_AUDIO_ID,
  TOGGLE_NEXT_CALL_VIDEO,
  TOGGLE_NEXT_CALL_AUDIO,
  RESET_CALL_SETTINGS,
  TOGGLE_REMEMBER_SETTINGS,
  SET_NEXT_CALL_OUTPUT
} from 'constants/AvSettingsModal';

export function selectNextCallVideoSource(id) {
  return {
    type: SAVE_NEXT_VIDEO_ID,
    payload: id
  };
}

export function selectNextCallAudioSource(id) {
  return {
    type: SAVE_NEXT_AUDIO_ID,
    payload: id
  };
}

export function toggleNextCallVideo() {
  return {
    type: TOGGLE_NEXT_CALL_VIDEO
  };
}

export function toggleNextCallAudio(toggle) {
  return {
    type: TOGGLE_NEXT_CALL_AUDIO,
    payload: toggle
  };
}

export function resetCallSettings() {
  return {
    type: RESET_CALL_SETTINGS
  };
}

export function toggleRememberSettings() {
  return {
    type: TOGGLE_REMEMBER_SETTINGS
  };
}

export function setNextCallOutput(id) {
  return {
    type: SET_NEXT_CALL_OUTPUT,
    payload: id
  };
}

export default {
  selectNextCallVideoSource,
  selectNextCallAudioSource,
  setNextCallOutput,
  toggleNextCallVideo,
  toggleNextCallAudio,
  resetCallSettings,
  toggleRememberSettings
};
